
import 'bootstrap/dist/css/bootstrap.css'
import '@fortawesome/fontawesome-pro/css/all.css'
import 'vue2-animate/dist/vue2-animate.min.css'

import '@/assets/scss/app.scss'
import '@/assets/fonts/RobotoCondensed/style.scss'

import cssVars from 'css-vars-ponyfill';

import './plugins/_globals'
import './components/_globals'

import Vue from 'vue'
import App from './App.vue'

import { store } from './store'
import router from './router'

Vue.config.productionTip = false

import Vue2TouchEvents from 'vue2-touch-events'
//import './registerServiceWorker'

Vue.use(Vue2TouchEvents);

new Vue({
	router,
	store,
	render: h => h(App),

}).$mount('#app')
